import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const ProductLiabilityFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. How much product liability insurance do I need?",
      answer: (
        <>
        To determine how much product liability insurance your business needs, consider your annual sales volume, the type of products you sell, and any specific risks associated with them. It's also important to review any contractual or regulatory requirements that may dictate minimum coverage amounts. Consulting with an insurance advisor can help you choose coverage that adequately protects your business against potential liability claims.


        </>
      )
    },
    {
      question: "Q2. Can you be sued for reselling products?",
      answer: (
        <>
         Yes, businesses can be sued for reselling products if those products cause harm or injury to consumers due to defects, inadequate warnings, misrepresentation, or breach of warranty. It's important for sellers to ensure products meet safety standards, provide accurate information, and consider having product liability insurance to protect against such risks.
       </>
      )
    },
    {
      question: "Q3. Does product liability insurance cover recalls?",
      answer:(
        <>
        Yes, product liability insurance can cover costs associated with product recalls under certain conditions. If a product defect or safety issue necessitates a recall to protect consumers from harm, the insurance policy may include coverage for expenses such as:
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Notification Costs:</span> Expenses related to informing customers, distributors, and the public about the recall.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Shipping and Retrieval Costs:</span> Expenses incurred in retrieving the defective products from the market.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Storage Costs:</span> Costs related to storing recalled products until they can be disposed of or corrected.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Refund or Replacement Costs:</span> Costs of reimbursing customers or providing replacements for the recalled products.

      </>
      )
      },

      {
        question: "Q4. Are there industry-specific product liability insurance options?",
        answer:(
          <>
        Yes, there are industry-specific product liability insurance options tailored to various sectors. For example:
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Medical Devices and Pharmaceuticals:</span> These industries often require specialized product liability coverage due to the unique risks associated with health-related products and potential regulatory requirements.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Food and Beverage: </span>Companies in this sector may need coverage that addresses specific risks like contamination or allergen-related issues.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Automotive:</span> Manufacturers, distributors, and retailers of automotive products may seek coverage that includes potential risks related to vehicle defects or malfunctioning parts.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Technology and Electronics: </span>This sector may require coverage that addresses issues such as product failures, data breaches, or software malfunctions.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Construction and Building Materials:</span> Companies in this industry may need coverage that protects against liability arising from defects in construction materials or equipment.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Toys and Consumer Goods:</span> Coverage for these industries might address risks related to product design flaws, choking hazards, or other safety concerns.
        </>
        )
        },
    {
      question: "Q5. Can product liability insurance cover damages caused by product misuse?",
      answer: (
        <>
          Yes, product liability insurance can cover damages caused by product misuse under certain conditions. While coverage specifics can vary depending on the policy and insurer, here are some key points:
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>1.Standard Coverage:</span> Many product liability policies include coverage for damages resulting from typical and foreseeable uses of the product as intended.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>2.Misuse Coverage: </span>Some policies may extend coverage to damages caused by unintended or misuse of the product, depending on the circumstances and the language of the policy.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>3.Policy Terms: </span>It's important to review the terms of your specific product liability insurance policy to understand the extent of coverage for misuse-related claims.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>4.Defining Misuse: </span>Insurers typically define misuse as the product being used in a manner not intended by the manufacturer or for purposes beyond its design specifications.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>5.Exclusions: </span>Policies may have exclusions for certain types of misuse or intentional misuse that results in harm, so it's essential to understand any limitations or exclusions in your coverage.
        </>
      )
      
    
    },
    {
      question: "Q6. What types of businesses benefit from product liability insurance?",
      answer: (
        <>
           Product liability insurance is essential for businesses that  <span style={{ color: "#F37435", fontWeight: "700"}} >manufacture, distribute, or sell products.</span> It protects against claims arising from product defects or hazards. This coverage is crucial for <span style={{ color: "#F37435", fontWeight: "700"}}>manufacturers, distributors, retailers, importers, exporters, and contract manufacturers,</span> helping them manage legal costs and settlements related to product-related incidents. By securing product liability insurance, businesses can safeguard their operations and reputation from potential financial risks.
        </>
      )
      
    },
    {
      question: "Q7. Does product liability insurance cover damages from defective design or manufacturing?",
      answer: (
      
       <>
        <span style={{ color: "#F37435", fontWeight: "700"}}> Product liability insurance covers damages caused by defective product designs or manufacturing errors. </span>It protects businesses by covering legal expenses, settlements, and judgments from claims related to these defects. This insurance is vital for managing financial risks and protecting business reputation against potential lawsuits.
        </>

      )
      
    },
  
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default  ProductLiabilityFAQ